<div class="toast_banner">
    <div>
        <mat-icon svgIcon="warning-icon"></mat-icon>
    </div>
    <div class="toast_banner_content">
        <div id="toastbanner_panel_header"><adp-label [labelKey]="headerText"></adp-label></div>
        <div id="toastbanner_midsize"><adp-label [labelKey]="subHeaderText"></adp-label></div>
    </div>
</div>